import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentModule } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApColComponent, ApRowComponent, ApSmDirective } from '@ap/grid';
import { ApInputComponent } from '@ap/input';

import { NameComponent } from './name.component';

/**
 * @ngdoc module
 * @name NameModule
 **/
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApFormErrorsComponent,
        ApFormControlPipe,
        ApSmDirective,
        ApColComponent,
        ApRowComponent,
        ApInputComponent,

        ReactiveFormsModule
    ],
    declarations: [NameComponent],
    exports: [NameComponent]
})
export class NameModule {}
